module.exports = __webpack_public_path__ + "static/img/LATRELLE-PICKETT.c7101b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/LATRELLE-PICKETT.jpg
// module id = oPwU
// module chunks = 0